var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.277px",
    height: "20.277px",
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64457 16.9984C6.04248 14.9012 8.42927 13.5194 11.1388 13.5194C13.8483 13.5194 16.2351 14.9011 17.633 16.9984M11.7002 21.2092C11.3389 21.3487 10.9386 21.3487 10.5772 21.2092C7.75502 20.1027 5.33177 18.1714 3.6234 15.6673C1.91504 13.1632 1.00084 10.2024 1 7.17103V2.60082C1 2.18713 1.16434 1.79039 1.45685 1.49787C1.74938 1.20535 2.14611 1.04102 2.5598 1.04102H19.7176C20.1313 1.04102 20.5281 1.20535 20.8205 1.49787C21.113 1.79039 21.2774 2.18713 21.2774 2.60082V7.15544C21.2798 10.1895 20.367 13.1536 18.6584 15.6608C16.9499 18.1681 14.5249 20.1016 11.7002 21.2092ZM11.1387 11.1797C13.077 11.1797 14.6483 9.60845 14.6483 7.67018C14.6483 5.73191 13.077 4.16062 11.1387 4.16062C9.20044 4.16062 7.62916 5.73191 7.62916 7.67018C7.62916 9.60845 9.20044 11.1797 11.1387 11.1797Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginInfoIcon);
export default __webpack_public_path__ + "static/media/loginInfoIcon.ffd108616c49e7112e7112c18027533b.svg";
export { ForwardRef as ReactComponent };